import useSWR, { mutate } from 'swr';
import fetcher from 'api/fetcher';

// ==============================|| SAYFALI/LOOKUP KOLEKSİYON HOOK'LARI (ORTAK) ||============================== //
// Bu dosya, api/*.js dosyalarında tekrarlanan yerel useKoleksiyon kopyalarının yerini alır.

function paramliAnahtar(temelUrl, params) {
  if (!params || Object.keys(params).length === 0) return temelUrl;
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null))
  ).toString();
  return qs ? `${temelUrl}?${qs}` : temelUrl;
}

// Sayfalı liste — {count,next,previous,results} dönen router list() endpoint'leri için.
export function useSayfaliKoleksiyon(temelUrl, adKok, params = {}) {
  const anahtar = paramliAnahtar(temelUrl, params);
  const { data, isLoading } = useSWR(anahtar, fetcher, { keepPreviousData: true });
  return {
    [adKok]: data?.results ?? [],
    [`${adKok}Toplam`]: data?.count ?? 0,
    [`${adKok}Loading`]: isLoading
  };
}

// Lookup — pagination_class=None dönen ViewSet'ler (bare array) için, eski imza korunur.
export function useKoleksiyon(key, adKok) {
  const { data, isLoading } = useSWR(key, fetcher);
  return { [adKok]: data ?? [], [`${adKok}Loading`]: isLoading };
}

// Dual-use kaynaklar (sayfalanan ama başka ekranlarda lookup olarak da kullanılan
// kaynaklar, ör. daireler/kisiler/calisanlar) — backend'in `page_size=all` opt-out'u
// (bkz. core.pagination.StandartSayfalama) ile TÜM kaydı çekip lookup olarak bare
// array döndürür; max_page_size (200) sınırına takılıp veri kesmez, çağıranların
// imzası değişmez.
export function useKoleksiyonTumu(temelUrl, adKok) {
  const { data, isLoading } = useSWR(`${temelUrl}?page_size=all`, fetcher);
  return { [adKok]: data ?? [], [`${adKok}Loading`]: isLoading };
}

export function kaynakOlustur(temelUrl) {
  const yenile = () => mutate((key) => typeof key === 'string' && key.startsWith(temelUrl));
  return { yenile };
}
